import { assertNotEmpty } from '@festina-life/core'

import { useUntilChangesetKeyValue } from '../../context/useUntilChangesetKeyValue'
import { configurationItem } from '../../system/paths'
import { useNavigationParams } from '../../system/useNavigationParams'
import type { TemplateVersionInfo } from '../../types/templateModel'
import { useOperationsContext } from '../../workspace/operationsContext'
import { OperationVersionTooltipEntry } from '../versionedTimeline/OperationVersionTooltipEntry'
import type { TooltipData } from '../versionedTimeline/VersionedArrowsGroup'
import { useIsTemplateVersionActive } from './useIsTemplateVersionActive'

export const TemplateVersionTooltipContent = ({
  versions,
  versionId,
}: TooltipData<TemplateVersionInfo>) => {
  const { workspaceKey, branchKey } = useOperationsContext()
  const { server } = useNavigationParams()
  const firstVersion = versions[0]
  const checkIsVersionActive = useIsTemplateVersionActive(versionId)
  const untilChangesetKeyValue = useUntilChangesetKeyValue()
  assertNotEmpty(firstVersion)

  return (
    <div className="flex flex-col gap-y-2">
      {versions.map((version) => {
        const isActive = checkIsVersionActive(version)
        const isDraft = version.isDraft
        const isInherited = version.identifier !== versionId
        const isHideVersion = version.isHideVersion
        const isLockedToChangeset =
          version.changesetHistory?.changesetKey === untilChangesetKeyValue

        const to = !version.isDraft
          ? configurationItem({
              layer: version.layer,
              block: version.block,
              itemId: version.identifier,
              type: 'template',
              workspaceName: workspaceKey?.name,
              branch: branchKey?.name,
              server: workspaceKey?.branchKey.server ?? server,
              untilChangesetKey: version.changesetHistory?.changesetKey,
            })
          : undefined
        const fromDate = version.fromDate
        const changesetHistory = version.changesetHistory

        return (
          <OperationVersionTooltipEntry
            key={version.operationKey}
            identifier={version.identifier}
            isActive={isActive}
            isDraft={isDraft}
            isInherited={isInherited}
            isHideVersion={isHideVersion}
            isLockedToChangeset={isLockedToChangeset}
            to={to}
            fromDate={fromDate}
            changesetHistory={changesetHistory}
            layer={version.layer}
            block={version.block}
          />
        )
      })}
    </div>
  )
}
